<!--suppress CheckImageSize, JSUnresolvedVariable -->
<template>
  <div
    class="nav-bg fixed-top shadow"
    :style="{ backgroundImage: 'url(' + backgroundUrl + ')' }"
  >
    <nav
      class="nav-header navbar navbar-expand-xl navbar-light p-0  animated fadeInDown"
    >
      <a class="navbar-brand my-2 ml-3" href="#">
        <img :src="logoImgUrl" alt="logo" />
      </a>
      <button
        class="navbar-toggler mr-3"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <div class="navbar-nav ml-auto mr-lg-5 text-center mb-xl-0 mb-2">
          <router-link
            class="nav-item nav-link"
            v-for="item in navList"
            :key="item.navId"
            :to="item.path"
            @click.native="hideCollapse()"
          >
            {{ item.navName }}
          </router-link>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
// noinspection JSUnusedGlobalSymbols
export default {
  inject: ["reload"],
  name: "NavHeader",
  data() {
    return {
      backgroundUrl: "",
      logoImgUrl: "",
      navList: [],
      title: "WingjoyGames",
      keywords: "WingjoyGames",
      description: "Wingjoy Games is always here for you"
    };
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          name: "keywords", // 设置关键字
          content: this.keywords
        },
        {
          name: "description", // 设置关键字
          content: this.description
        }
      ]
    };
  },
  mounted() {
    this.getSiteInfo();
    this.getNavList();
  },
  methods: {
    hideCollapse() {
      // eslint-disable-next-line no-undef
      $("#navbarSupportedContent").collapse("hide");
    },
    getSiteInfo() {
      this.axios
        .get("/siteInformation/getSiteInfo")
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.logoImgUrl = resp.data.data.siteLogo;
            this.backgroundUrl = resp.data.data.topBackground;
            this.title =
              resp.data.data.siteTitle + "-" + resp.data.data.siteSubTitle;
            this.keywords = resp.data.data.siteKeyword;
            this.description = resp.data.data.siteDesc;
          }
        })
        .catch();
    },
    getNavList() {
      this.axios
        .get("/navigation/getNavList")
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.navList = resp.data.data;
          }
        })
        .catch();
    }
  }
};
</script>

<style scoped lang="scss">
.nav-bg {
  background-size: cover;
  background-repeat: no-repeat;
}

.nav-header {
  background: rgba(255, 255, 255, 0.8);

  .collapse {
    .navbar-nav {
      .active,
      a:hover {
        color: #ff530a;
        font-weight: bolder;
        border-bottom: 2px #ff530a solid;
      }

      a {
        font-size: 16px;
        padding: 0 15px;
        height: 67px;
        line-height: 67px;
      }

      /*sm屏幕以下*/
      @media only screen and (max-width: 1140px) {
        a {
          font-size: 16px;
          padding: 0 15px;
          height: 40px;
          line-height: 40px;
        }
      }
    }
  }
}
</style>
